export default {
  setZones (state, payload) {
    state.list = payload
  }
}